import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import OrderDrawer from "@/components/OrderDrawer";

export default function Layout() {
  useEffect(() => {
    const prev = document.body.style.cssText;
    document.body.style.backgroundImage = "linear-gradient(rgba(255,255,255,0.2), rgba(255,255,255,0.2)), url('/brand/pattern.jpg?v=4')";
    document.body.style.backgroundRepeat = "repeat";
    document.body.style.backgroundSize = "900px auto";
    document.body.style.backgroundAttachment = "fixed";
    return () => { document.body.style.cssText = prev; };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-transparent">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <OrderDrawer />
    </div>
  );
}
